// extracted by mini-css-extract-plugin
export default {"CopilotIconAnimationContainer":"CopilotIconAnimation-module__CopilotIconAnimationContainer--D7ThL","copilotAnimation":"CopilotIconAnimation-module__copilotAnimation--GjmmG"};